import {
  API_BASE_URL
} from 'shared/utils/Constants';

export const GET_GALLERY_URL = token => {
  return `${API_BASE_URL}/gallery/${token}/settings`;
}

export const GET_MOMENTS_URL = (token, page, perPage) => {
  return `${API_BASE_URL}/gallery/${token}/moments?page=${page}&per_page=${perPage}`;
}

export const GALLERY_DOWNLOAD_URL = (token, momentIds, filename) => {
  return `${API_BASE_URL}/download/gallery/${token}/${btoa(momentIds.join('+'))}/${filename}`;
}

export const CREATE_SHARE_PAGE_URL = token => {
  return `${API_BASE_URL}/share_page/${token}`;
}
